import React from 'react';

interface PageComponentMainHeaderProps {
  header: string;
  caption?: string;
  className?: string;
}

export const PageComponentMainHeader = ({
  header,
  caption,
  className,
}: PageComponentMainHeaderProps) => {
  return (
    <div className={`flex-column ${className}`}>
      <h1 className="mb-2 font-title text-headingm text-text-default lg:text-headingl">
        {header}
      </h1>
      {caption && (
        <h2 className={`font-title text-headings lg:text-headingm`}>
          {caption}
        </h2>
      )}
    </div>
  );
};
